import { render, staticRenderFns } from "./TotpMfaSetting.vue?vue&type=template&id=66887910"
import script from "./TotpMfaSetting.vue?vue&type=script&lang=js"
export * from "./TotpMfaSetting.vue?vue&type=script&lang=js"
import style0 from "./TotpMfaSetting.vue?vue&type=style&index=0&id=66887910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VTextField})
